export default __webpack_public_path__ + "static/media/settingsIcon.b2655967.svg";